<template>
  <div>
    <div class="position-relative">
      <section
        class="section  section-sm bg-custom-bg-color"
        style="margin-top: 90px"
      >
        <div class="container p-0">
          <div
            class="bg-white p-3 rounded-3"
            v-if="!isEmpty(commodity_data) && !is_not_found"
          >
            <div class="row m-0 align-items-center">
              <TagItem
                :text="is_stock ? '庫存' : '預訂'"
                :color="is_stock ? 'yellow' : ''"
              />
              <span class="ml-3" />
              <h2 class="m-0 display-3 text-custom-text">{{ title }}</h2>
              <span class="ml-2" />
              <button
                  type="button"
                  class="btn no-hover btn-icon-only commodity-favorite-button"
                  :class="{'is-favorited': isFavorited}"
                  :disabled="isTogglingFavorite"
                  @click="toggleFavorite"
              >
                <i :class="['fa', isFavorited ? 'fa-heart' : 'fa-heart-o']"></i>
              </button>
            </div>

            <div class="row  m-0 align-items-center justify-content-sm-end ">
              <TagItem :text="'單號'" :color="'white'" />
              <span class="ml-1" />
              <span>{{ formatNumberLength(number, 8) }}</span>
              <button
                class="btn no-hover btn-icon-only"
                @click="clickCopy(formatNumberLength(number, 8))"
              >
                <i class="fa fa-clone"></i>
              </button>
              <span class="ml-2" />
              <button
                class="btn btn-sm"
                style="background-color: #E89100; color: #ffffff; border-color: #E89100;"
                @click="downloadExcel"
                :disabled="isDownloading"
              >
                <i class="fa fa-download mr-1"></i>{{ isDownloading ? '下載中...' : '下載' }}
              </button>
              <span class="ml-2" />
              <button class="btn btn-sm btn-outline-secondary" @click="setView(false)" :class="{ active: !isListView }">
                <i class="fa fa-th-large mr-1"></i>圖像模式
              </button>
              <button class="btn btn-sm btn-outline-secondary ml-1" @click="setView(true)" :class="{ active: isListView }">
                <i class="fa fa-list mr-1"></i>條列模式
              </button>
            </div>

            <div class="mt-3"></div>

            <!-- 卡片模式 -->
            <div v-if="!isListView" class="grid-container px-3">
              <div
                v-for="(item, index) in commodity_data.items"
                :key="index"
                class="grid-item"
              >
                <CommodityItem v-bind="item" :isNew="isItemNew(item)" @update="updatePrice" />
              </div>
            </div>

            <!-- 列表模式 -->
            <div v-else class="px-3">
              <div class="table-responsive">
                <table class="table table-bordered table-hover align-middle">
                  <thead class="thead-light">
                    <tr>
                      <th style="width:50px">#</th>
                      <th style="width:150px">圖片</th>
                      <th style="min-width:180px; max-width:280px">商品名稱</th>
                      <th style="width:80px">售價</th>
                      <th style="width:70px">單位</th>
                      <th style="width:110px">數量</th>
                      <th style="width:110px">官方代訂數量</th>
                      <th v-if="remarkEnabled" style="min-width:180px">商品備註</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in commodity_data.items" :key="item.id">
                      <td class="text-center">{{ item.serial_id }}</td>
                      <td class="text-center p-1">
                        <WatermarkImage style="width:130px; height:130px; margin:auto; display:block;">
                          <img
                            v-if="item.Images && item.Images.length > 0"
                            :src="imgIsEmpty(item.Images[0])"
                            style="width:130px; height:130px; object-fit:contain;"
                          />
                          <div
                            v-else
                            style="width:130px; height:130px; background-color:#F6F8FB; color:#E0E4EB; display:flex; flex-direction:column; align-items:center; justify-content:center; border-radius:4px;"
                          >
                            <i class="fa fa-picture-o" style="font-size:30px;"></i>
                            <span style="font-size:14px;">未上傳圖片</span>
                          </div>
                        </WatermarkImage>
                      </td>
                      <td>
                        <div class="font-weight-500">{{ item.chinese_name }}</div>
                        <div class="d-flex flex-wrap mt-1" style="gap:4px">
                          <TagItem v-if="isItemNew(item)" :text="'最新'" :color="'yellow'" />
                          <TagItem v-if="item.CommodityBrand" :text="item.CommodityBrand.name" :color="'blue'" />
                          <TagItem v-if="item.CommodityType" :text="item.CommodityType.name" :color="'green'" />
                        </div>
                        <div v-if="item.note" class="font-size-11 text-custom-gray-2 mt-1" style="word-break:break-all; white-space:normal">{{ item.note }}</div>
                        <div v-if="item.jan_code" class="d-flex align-items-center mt-1" style="gap:4px">
                          <TagItem :text="'Jan Code'" :color="'white'" />
                          <span class="font-size-14">{{ item.jan_code }}</span>
                          <button class="btn no-hover btn-icon-only p-0" @click="clickCopy(item.jan_code)">
                            <i class="fa fa-clone font-size-12 text-custom-gray-2"></i>
                          </button>
                        </div>
                      </td>
                      <td class="text-right">{{ formatPrice(calcItemPrice(item)) }} 元</td>
                      <td class="text-center">{{ listViewAmounts[item.id] ? listViewAmounts[item.id].unitType.text : '' }}</td>
                      <td class="text-center">
                        <template v-if="catalog_data && catalog_data.is_orderable !== false">
                          <input
                            v-if="listViewAmounts[item.id]"
                            type="number"
                            inputmode="numeric"
                            class="form-control form-control-sm text-right list-qty-input"
                            v-model.number="listViewAmounts[item.id].amount"
                            min="0"
                          />
                        </template>
                        <template v-else>
                          {{ listViewAmounts[item.id] ? listViewAmounts[item.id].amount : 0 }}
                        </template>
                      </td>
                      <td class="text-center">
                        <!-- 廠商調整後的數量：無調整顯示「－」，調整顯示數字，取消顯示紅色 0 -->
                        <span v-if="adjustInfo(item).kind === 'none'" class="text-custom-gray-2">－</span>
                        <span v-else-if="adjustInfo(item).kind === 'cancelled'" style="color: #d9534f; font-weight: 600">0</span>
                        <span v-else class="text-main-color font-weight-600">{{ adjustInfo(item).value }}</span>
                      <td v-if="remarkEnabled">
                        <template v-if="catalog_data && catalog_data.is_orderable !== false">
                          <textarea
                            v-if="listViewAmounts[item.id]"
                            v-model="listViewAmounts[item.id].remark"
                            class="form-control form-control-sm list-remark-input"
                            rows="2"
                            maxlength="255"
                            placeholder="商品備註（選填，最多 255 字）"
                          ></textarea>
                          <div v-if="listViewAmounts[item.id]" class="text-right font-size-11 text-custom-gray-2">
                            {{ (listViewAmounts[item.id].remark || '').length }} / 255
                          </div>
                        </template>
                        <div v-else style="white-space:pre-wrap; word-break:break-all">{{ listViewAmounts[item.id] ? listViewAmounts[item.id].remark : '' }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="catalog_data && catalog_data.is_orderable !== false" class="text-right mt-2 mb-3">
                <base-button type="main-color" size="lg" :disabled="isBatchSubmitting" @click="batchSubmit">
                  <i class="fa fa-check mr-1"></i>{{ isBatchSubmitting ? '送出中...' : '全部送出' }}
                </base-button>
              </div>
            </div>
            <IntersectionObserver
              sentinal-name="commodity-sentinel"
              @on-intersection-element="onIntersectionElement"
            ></IntersectionObserver>
            <div
              v-if="isLoadMore || finished"
              class="d-flex w-100 mt-3 justify-content-center align-items-center"
            >
              <b-spinner v-if="isLoadMore" label="Loading..."></b-spinner>
              <p v-if="finished">已無更多資料</p>
            </div>
          </div>

          <div
            class="bg-white p-5 rounded-3 text-center"
            v-else-if="is_not_found"
          >
            <h2 class="display-3 text-custom-text">找不到資料</h2>
            <p class="lead">請確認連結是否正確，或該項目已不存在。</p>
            <base-button
              type="main-color"
              @click="$router.push('/')"
              class="mt-4"
              >回到首頁</base-button
            >
          </div>
        </div>
      </section>

      <div
        class="bg-white position-fixed w-100  bottom-0 "
        style="min-height: 130px; z-index: 1;"
        v-if="!is_not_found"
      >
        <div class="m-auto" style="max-width: 1040px">
          <div class="mx-3 my-3">
            <div class="row m-0 mb-2">
              <div class="font-size-12 pr-3 text-sm-left text-center">
                <span class="text-custom-description pr-1">採購名稱</span>
                <span class="text-custom-text">{{ user_data.name }}</span>
              </div>
              <div class="font-size-12 pr-3">
                <span class="text-custom-description pr-1">Email</span>
                <span class="text-custom-text">{{ user_data.email }}</span>
              </div>
              <div class="font-size-12 ">
                <span class="text-custom-description pr-1">電話</span>
                <span class="text-custom-text">{{ user_data.phone }}</span>
              </div>
            </div>

            <div class="row align-items-end">
              <div class="col-lg-6 col-sm-6 col-12 ">
                <TagItem v-if="expire_time !== null" :text="'距結單還剩'" :color="'white'" />
                <div class="h4">{{ expire_time !== null ? expire_time : '已結單' }}</div>
              </div>

              <div class="col-lg-6 col-12">
                <div class="col-sm-12 col-12 text-right">
                  <div class="font-size-12 font-weight-600 text-custom-text-2">
                    總金額試算
                  </div>
                  <div class="h2 m-0 font-weight-600 text-custom-text-2">
                    TWD${{ formatPrice(totalPrice) }}
                    <span class="h6 m-0 font-weight-600 text-custom-text-2"
                      >元</span
                    >
                  </div>
                  <div class="text-custom-description font-size-12">
                    *實際出貨價依到貨匯率為準
                  </div>
                </div>
                <!--                  <div class="col-sm-4 col-12">-->
                <!--                    <base-button class="w-100" style="max-width: 170px" size="lg" type="main-color" @click="">查看訂單</base-button>-->
                <!--                  </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog
      dataTarget="batchResultDialog"
      :title="batchDialogTitle"
      :context="batchDialogContext"
      confirmText="確認"
      onlyConfirm
      centered
    />
  </div>
</template>

<script>
import TagItem from "@/views/components/elements/TagItem";
import WatermarkImage from "@/components/WatermarkImage.vue";
import CommodityItem from "@/views/components/elements/CommodityItem";
import Dialog from "@/components/Dialog";
import IntersectionObserver from "@/components/IntersectionObserver.vue";
import { clickCopy, isEmpty, imgIsEmpty } from "@/util/helpers";
import axios from "axios";
import { exportViaJob } from "@/util/export_job";
import * as Api from "@/util/http_api";
import { getCommodities, getTotalPrice } from "@/util/http_api";
import { VUE_APP_APIPATH } from "@/util/globals";
import { checkError } from "@/util/error_handler";
import { formatPrice, formatNumberLength, timeLeft } from "@/util/formatter";

export default {
  name: "CommodityView",
  components: {
    IntersectionObserver,
    TagItem: TagItem,
    CommodityItem: CommodityItem,
    Dialog: Dialog,
    WatermarkImage,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    is_stock: {
      type: Boolean,
      default: false,
    },
    // commodity_list: {
    //   type: Array,
    //   default: () =>
    //       [
    //         {
    //           number: 1,
    //           is_stock: false,
    //           title: '安妮亞01',
    //           note: "附水晶眼特典附水晶眼特典附備註文字",
    //           img: "/img/anya/anya01.png",
    //           release_date_text: "2023年01月發售",
    //           discount: 0.75,
    //           combine_buy_discount: 0.8,
    //           tag_list: [
    //             {text: 'Good Smile Company', color: 'blue'},
    //             {text: 'PVC', color: 'green'},
    //           ],
    //           original_price: 999,
    //           price: 499,
    //           amount: 1,
    //           jan_code: "4904810907305",
    //           commodity_code: 'F-TA90730',
    //           init_is_combine_buy: true,
    //           init_combine_buy_amount: 10,
    //           stock: 29,
    //           img_list: [
    //             {img: "/img/anya/anya01.png"},
    //             {img: "/img/anya/anya02.png"},
    //             {img: "/img/anya/anya03.png"},
    //           ],
    //           last_order_amount: 0,
    //           exchange_rate: 0.22,
    //           unit_list: [
    //             {
    //               text: '盒',
    //               amount: 6
    //             },
    //             {
    //               text: '箱',
    //               amount: 24
    //             },
    //             {
    //               text: 'PCS',
    //               amount: 1
    //             },
    //           ],
    //           unit_type: {
    //             text: 'PCS',
    //             amount: 1
    //           },
    //         },
    //         {
    //           number: 2,
    //           is_stock: true,
    //           title: '安妮亞02',
    //           note: "",
    //           img: "/img/anya/anya02.png",
    //           release_date_text: "2023年02月發售",
    //           discount: 0.60,
    //           combine_buy_discount: 0.80,
    //           tag_list: [
    //             {text: 'Good Smile Company', color: 'blue'},
    //             {text: 'PVC', color: 'green'},
    //           ],
    //           original_price: 999,
    //           price: 499,
    //           amount: 200,
    //           jan_code: "4904810907300",
    //           commodity_code: 'F-TA90729',
    //           init_is_combine_buy: false,
    //           init_combine_buy_amount: 1,
    //           stock: 1,
    //           img_list: [
    //             {img: "/img/anya/anya04.png"},
    //             {img: "/img/anya/anya05.png"},
    //             {img: "/img/anya/anya06.png"},
    //           ],
    //           last_order_amount: 0,
    //           exchange_rate: 0.22,
    //           unit_list: [
    //             {
    //               text: '盒',
    //               amount: 6
    //             },
    //             {
    //               text: '箱',
    //               amount: 24
    //             },
    //             {
    //               text: 'PCS',
    //               amount: 1
    //             },
    //           ],
    //           unit_type: {
    //             text: 'PCS',
    //             amount: 1
    //           },
    //         },
    //         {
    //           number: 3,
    //           is_stock: true,
    //           title: '安妮亞01',
    //           note: "附水晶眼特典附水晶眼特典附備註文字",
    //           img: "/img/anya/anya03.png",
    //           release_date_text: "2023年03月發售",
    //           discount: 0.70,
    //           combine_buy_discount: 0.85,
    //           tag_list: [
    //             {text: 'Good Smile Company', color: 'blue'},
    //             {text: 'PVC', color: 'green'},
    //           ],
    //           original_price: 999,
    //           price: 499,
    //           amount: 200,
    //           jan_code: "4904810907304",
    //           commodity_code: 'F-TA90731',
    //           init_is_combine_buy: false,
    //           init_combine_buy_amount: 1,
    //           stock: 29,
    //           img_list: [
    //             {img: "/img/anya/anya07.png"},
    //             {img: "/img/anya/anya08.png"},
    //             {img: "/img/anya/anya09.png"},
    //           ],
    //           last_order_amount: 0,
    //           exchange_rate: 0.22,
    //           unit_list: [
    //             {
    //               text: '盒',
    //               amount: 6
    //             },
    //             {
    //               text: '箱',
    //               amount: 24
    //             },
    //             {
    //               text: 'PCS',
    //               amount: 1
    //             },
    //           ],
    //           unit_type: {
    //             text: 'PCS',
    //             amount: 1
    //           },
    //         },
    //       ]
    // },
    // user_data: {
    //   type: Object,
    //   default: () => {
    //     return {
    //       name: "台中HOBBY天國",
    //       email: "user@mail.com.tw",
    //       phone: "02-1234-456",
    //     };
    //   },
    // },
    // expire_time: {
    //   type: String,
    //   default: " - ",
    // }
  },
  data() {
    return {
      title: "",
      options: {
        page: 1,
        itemsPerPage: 12,
      },
      is_notify: false,
      isDownloading: false,
      totalPrice: 0,
      totalPriceMap: {},
      commodity_data: null,
      isIntersectingElement: false,
      isLoadMore: false,
      finished: false,
      catalog_data: null,
      user_data: {},
      number: "",
      expire_time: " - ",
      is_not_found: false,
      isListView: false,
      listViewAmounts: {},
      isBatchSubmitting: false,
      batchDialogTitle: '',
      batchDialogContext: '',
      isFavorited: false,
      isTogglingFavorite: false,
    };
  },
  computed: {
    remarkEnabled() {
      const org = this.$store.state.myOrganization;
      return !!org && org.enable_item_remark === true;
    },
  },
  created() {
    this.init();
    this.updatePrice();
  },
  methods: {
    // 廠商調整數量的狀態（邏輯與圖像模式一致）：調整後數量等於店家下訂數量視同沒有調整；
    // 店家有下單卻被調成 0 就是取消
    adjustInfo(item) {
      const pre = item.PreOrderCommodity;
      if (!pre || pre.additional_amount === null || pre.additional_amount === undefined) return {kind: 'none'};
      const ordered = Number(pre.amount) || 0;
      const adjusted = Number(pre.additional_amount);
      if (adjusted === 0 && ordered > 0) return {kind: 'cancelled'};
      if (adjusted === 0 || adjusted === ordered) return {kind: 'none'};
      return {kind: 'adjusted', value: adjusted};
    },
    isItemNew(item) {
      return !!item.is_new;
    },
    formatPrice: formatPrice,
    formatNumberLength: formatNumberLength,
    init() {
      this.number = this.$route.params.id;
      this.user_data = this.$store.state.myOrganization;
      this.getCommodities();
      this.getCatalog();
      this.fetchTotalPrice();
    },
    async getDataFromApi() {},
    async fetchTotalPrice() {
      try {
        const catalog_id = Number(this.$route.params.id);
        this.totalPrice = await getTotalPrice({catalog_id});
      } catch (e) {
        console.error('fetchTotalPrice error', e);
      }
    },
    updatePrice(commodity_id, total_price) {
      if (commodity_id === undefined) return;
      this.fetchTotalPrice();
    },
    clickCopy(str) {
      clickCopy(str);
    },
    async downloadExcel() {
      const catalog_id = String(this.$route.params.id);
      this.isDownloading = true;
      try {
        const filter = JSON.stringify({ 'catalog_id.include': catalog_id, catalog_id: catalog_id });
        const url = VUE_APP_APIPATH + 'model/preOrderCommodities/export_excel';
        const headers = await this.$store.dispatch('getAuthHeader');
        // 匯出改為背景 Job：啟動 → 輪詢 → 下載（見 util/export_job.js）
        const response = await exportViaJob({
          url,
          params: { filter },
          headers,
          statusBase: VUE_APP_APIPATH + 'model/export_jobs',
        });
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        const disposition = response.headers['content-disposition'] || '';
        const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^;"'\n]+)/i);
        link.download = match ? decodeURIComponent(match[1]) : `preorder_${catalog_id}.xlsx`;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (e) {
        // 匯出被拒絕（匯出進行中、系統忙碌、資料量過大…）時顯示後端的明確訊息
        const text = e && e.response && e.response.data && e.response.data.error && e.response.data.error.text;
        alert(text || '下載失敗');
      } finally {
        this.isDownloading = false;
      }
    },
    imgIsEmpty(img) {
      return imgIsEmpty(img);
    },
    isEmpty(val) {
      return isEmpty(val);
    },
    async setView(isList) {
      this.isListView = isList;
      if (isList) {
        await this.getCommodities();
        this.initListView();
      }
    },
    initListView() {
      const amounts = {};
      const items = this.commodity_data ? this.commodity_data.items : [];
      for (const item of items) {
        const unitList = this.getUnitList(item.commodity_units);
        const unitType = unitList[0] || { text: 'PCS', amount: 1, unit_count: 1 };
        const currentAmount = item.PreOrderCommodity ? (item.PreOrderCommodity.amount || 0) : 0;
        amounts[item.id] = { amount: currentAmount, unitType, remark: item.remark || '' };
      }
      this.listViewAmounts = amounts;
    },
    getUnitList(commodity_units) {
      if (!commodity_units) return [{ text: 'PCS', amount: 1, unit_count: 1 }];
      const unitList = [];
      for (const key of Object.keys(commodity_units)) {
        if (!key.endsWith('value')) continue;
        const [unit] = key.split('_');
        const unit_count = commodity_units[`${unit}_unit`] || 1;
        unitList.push({ text: unit, amount: commodity_units[key], unit_count });
      }
      return unitList.length > 0 ? unitList : [{ text: 'PCS', amount: 1, unit_count: 1 }];
    },
    calcItemPrice(item) {
      const d = item.discount > 1 ? item.discount / 100 : item.discount;
      const rate = item.OfficialMonetaryType ? item.OfficialMonetaryType.exchange_rate : 1;
      switch (item.commodity_price_calc_type) {
        case 'sale_price_discount': return Math.ceil(item.official_price * d * 100) / 100;
        case 'exchange_rate_discount': return Math.ceil(item.official_price * rate * d * 100) / 100;
        case 'sell_price': return item.sell_price || 0;
        default: return item.sell_price || item.official_price || 0;
      }
    },
    async batchSubmit() {
      this.isBatchSubmitting = true;
      try {
        const catalog_id = parseInt(this.$route.params.id);
        const items = this.commodity_data ? this.commodity_data.items : [];
        const responses = await Promise.all(items.map(item => {
          const state = this.listViewAmounts[item.id];
          if (!state) return Promise.resolve(null);
          return Api.updateOrderCommodity({
            catalog_id,
            commodity_id: item.id,
            operate_amount: state.amount,
            is_combine_buy: false,
            combine_buy_amount: 0,
            // 門市開放商品備註才送；內容與已存的相同也一併送，後端會略過沒變動的檢查
            remark: this.remarkEnabled ? (state.remark || '').trim() : undefined,
          });
        }));
        // 後端以 200 + status:'fail' 回傳單筆錯誤（例如備註超過 255 字），要逐筆檢查；
        // 其他商品仍然會被儲存，所以先更新總覽，錯誤只提示第一筆
        const failed = responses.find(r => r && String(r.status).toLowerCase() === 'fail');
        await this.getCommodities();
        await this.fetchTotalPrice();
        if (failed) {
          checkError(null, failed);
          return;
        }
        this.initListView();
        this.batchDialogTitle = '送出成功';
        this.batchDialogContext = '訂單已更新完成。';
        window.jQuery('#batchResultDialog').modal('show');
      } catch (e) {
        console.error(e);
        this.batchDialogTitle = '送出失敗';
        this.batchDialogContext = '請稍後再試，或聯繫官方人員。';
        window.jQuery('#batchResultDialog').modal('show');
      } finally {
        this.isBatchSubmitting = false;
      }
    },
    async getCatalog() {
      try {
        let catalog_id = this.$route.params.id;
        this.catalog_data = await Api.getCatalog(catalog_id);
        if (!this.catalog_data) {
          this.is_not_found = true;
          return;
        }
        const daysLeft = this.catalog_data.final_date ? require('moment')(this.catalog_data.final_date).diff(require('moment')(), 'days') : null;
        this.expire_time = daysLeft !== null && daysLeft < 0 ? null : timeLeft(this.catalog_data.final_date);
        console.log("catalog_data ", this.catalog_data);
        this.title = this.catalog_data.name;
        this.isFavorited = await Api.isFavoriteCatalog(catalog_id);
      } catch (e) {
        console.error(e);
        this.is_not_found = true;
      }
    },
    async toggleFavorite() {
      if (this.isTogglingFavorite) return;
      this.isTogglingFavorite = true;
      const next = !this.isFavorited;
      this.isFavorited = next; // 先樂觀更新畫面
      try {
        const catalog_id = this.$route.params.id;
        if (next) {
          await Api.addFavoriteCatalog(catalog_id);
        } else {
          await Api.removeFavoriteCatalog(catalog_id);
        }
      } catch (e) {
        console.error('toggleFavorite error', e);
        this.isFavorited = !next; // 失敗則還原
      } finally {
        this.isTogglingFavorite = false;
      }
    },
    async getCommodities() {
      try {
        let catalog_id = this.$route.params.id;
        // initial load: fetch first page
        this.commodity_data = await Api.getCommodities({
          limit: this.options.itemsPerPage,
          offset: 0,
          catalog_id: catalog_id,
        });
        console.log("commodity_data ", this.commodity_data);
        this.finished =
          this.commodity_data.items.length >= this.commodity_data.total;
      } catch (e) {
        console.error(e);
      }
    },
    onIntersectionElement(value) {
      this.isIntersectingElement = value;
      if (value) {
        this.loadMore();
      }
    },
    async loadMore() {
      try {
        if (this.isLoadMore || this.finished) return;
        this.isLoadMore = true;
        const catalog_id = this.$route.params.id;
        const offset = this.commodity_data
          ? this.commodity_data.items.length
          : 0;
        const data = await Api.getCommodities({
          limit: this.options.itemsPerPage,
          offset: offset,
          catalog_id: catalog_id,
        });
        // append items into existing ListData
        if (!this.commodity_data) {
          this.commodity_data = data;
        } else {
          this.commodity_data.add(data.items);
        }
        this.finished = this.commodity_data.items.length >= data.total;
        if (this.isListView) {
          for (const item of data.items) {
            if (!this.listViewAmounts[item.id]) {
              const unitList = this.getUnitList(item.commodity_units);
              const unitType = unitList[0] || { text: 'PCS', amount: 1, unit_count: 1 };
              const currentAmount = item.PreOrderCommodity ? (item.PreOrderCommodity.amount || 0) : 0;
              this.$set(this.listViewAmounts, item.id, { amount: currentAmount, unitType });
            }
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoadMore = false;
        if (!this.finished && this.isIntersectingElement) {
          this.$nextTick(() => this.loadMore());
        }
      }
    },
  },
};
</script>

<style scoped>
.list-remark-input,
.list-remark-input:focus {
  resize: none;
  color: #000;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(305px, 1fr));
  grid-gap: 20px 30px;
}

/* iOS Safari 對 type=number 有預設內建樣式，需強制覆蓋才能正常顯示數值 */
.list-qty-input {
  -webkit-appearance: none;
  appearance: none;
  min-width: 60px;
}
.list-qty-input::-webkit-outer-spin-button,
.list-qty-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.list-qty-input::-webkit-input-placeholder {
  color: #aaa;
}

.commodity-favorite-button {
  width: 34px;
  height: 34px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #f5f5f5;
  border: none;
  transition: background-color 0.15s ease, transform 0.15s ease;
}

.commodity-favorite-button i {
  font-size: 18px;
  color: #a0a0a0;
}

.commodity-favorite-button.is-favorited i {
  color: #e0245e;
}

.commodity-favorite-button:hover {
  background-color: #ececec;
  transform: scale(1.08);
}

.commodity-favorite-button:disabled {
  opacity: 0.7;
}
</style>
